import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { PeopleModel } from '../model/peopleModel.model';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  headers: HttpHeaders;
  apiServer: string;

  constructor(private http: HttpClient, private apiRef: ApiProviderService) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    this.apiServer = 'api/GlobalSearch/';
   }

   getContactSuggestionsFromDatabase(searchData): Observable<Array<PeopleModel>>{
    const body = searchData;
    return this.http.post(this.apiRef.getApiUrl(`${this.apiServer}GetContactSuggestionsFromDatabase`), body)
      .pipe(map(resp => {
        resp = JSON.parse(resp.toString());
        if(resp && resp!=='null'){
          return resp as Array<PeopleModel>;
        } else {
          return new Array<PeopleModel>();
        }
      }));

   }
}
